import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  ViewEncapsulation
} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {ToolsBoxService} from '../../Services/tools.service';
import {UserService} from '../../Services/user.service';
import {BalanceHolder} from '../../Models/Holders/balanceholder.model';
import {CalendarEventHolder} from '../../Models/Holders/calendareventholder.model';
import {User} from '../../Models/user.model';
import {Workday} from '../../Models/work-day.model';
import {DatePipe, NgClass} from '@angular/common';
import {DayRepartition, WorkingDayConfigHolder} from "../../Models/Holders/workingDaysConfigHolder";
import {SelectBoxComponent} from '../../SelectBox/selectbox.component';
import {InfoPanelComponent} from '../Shared/info-panel/info-panel.component';
import {FollowUsPanelComponent} from '../Shared/follow-us-panel/follow-us-panel.component';
import {NotificationModalComponent} from '../../Modals/notificationmodal.component';

@Component({
    selector: 'dashboard',
    templateUrl: 'dashboard.component.html',
    styleUrls: ['dashboard.component.css'],
    providers: [DatePipe],
    encapsulation: ViewEncapsulation.None,
    imports: [SelectBoxComponent, NgClass, InfoPanelComponent, RouterLink, FollowUsPanelComponent, NotificationModalComponent, DatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardComponent implements OnInit, OnChanges {

  @Input() selectedUser: User = null;
  @Input() displayedAsTab = false;

  years: number[] = [new Date().getFullYear() - 1, new Date().getFullYear()];
  selectBoxOpen = false;

  authentificatedUser: User = new User;
  startDate: string;
  endDate: string;
  daysOff: string;
  workTimePercent = '100%';

  workingConfigs: WorkingDayConfigHolder[] = [];
  readonly dayKeys: (keyof DayRepartition)[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
  readonly dayLabels = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];

  balanceYear: number = new Date().getFullYear();
  eholDetail: CalendarEventHolder[];
  offDetail: CalendarEventHolder[];
  otherDetail: CalendarEventHolder[];
  sickDetail: CalendarEventHolder[];
  kidsDetail: CalendarEventHolder[];
  trainDetail: CalendarEventHolder[];
  dolDetail: CalendarEventHolder[];
  pholList: CalendarEventHolder[];
  pendingRequests: CalendarEventHolder[];
  currentYearBalance: number;
  previousYearFinalBalance: number;
  offCount: number;
  eholCount: number;
  takenCount: number;
  sickDaysCount: number;
  kidsSickDaysCount: number;
  dolCount: number;
  maxDol: number = null;

  //Information displayed
  nextEvents: CalendarEventHolder[] = [];
  upcomingEvents: CalendarEventHolder[] = [];
  nextDayOff: CalendarEventHolder;

  selectedYear: number = new Date().getFullYear();

  //Event label
  eventTypeLabels: any;

  //DataList
  modalLabel: string;
  modalType: string;
  displayDetail = false;
  currentDetail: CalendarEventHolder[];

  constructor(private datePipe: DatePipe, private userService: UserService, private toolsBoxService: ToolsBoxService, private router: Router, private cdr: ChangeDetectorRef) {
  }

  //
  ngOnChanges() {
    //If there is no selected user, we display Main Dashboard
    //Balance initialisation is required.
    if (this.selectedUser) {
      // console.log('Dashboard - onChange => getUserStats', this.selectedUser);
      this.getUserStats();
      this.getOffDaysByUser();
    }
    //If this.selectedUser is set, we display the Dashboard from Overview Component
    //Balance init is not required yet
  }

  ngOnInit() {

    this.getUserProfileInformations();

    if (!this.selectedUser) {
      //If this function is called with a selectedUser, we do not change the HeaderName since we are in the Admin Overview
      this.toolsBoxService.changeHeaderName("Dashboard");
    }
    this.toolsBoxService.tellChildContainsTabs(false);
    this.eventTypeLabels = this.toolsBoxService.eventLabels;
    //If there is no selected user, we display Main Dashboard
    //Balance initialisation is required.
    if (this.selectedUser === null) {
      this.getUserStats();
    }
    //If this.selectedUser is set, we display the Dashboard from Overview Component
    //Balance init is not required yet
  }

  getUserProfileInformations = () => {
    this.authentificatedUser.id = Number(this.toolsBoxService.getStoredUserId());

    this.toolsBoxService.tellActionIsInProgress(true);
    this.userService.getUserInformation(this.authentificatedUser).subscribe({
      next: (user: User) => {
        this.authentificatedUser = user;
        this.startDate = "FIX ME"
        this.endDate ="FIX ME";
        if (user.avatar) {
          this.toolsBoxService.changeAvatar(user.avatar);
        }
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.toolsBoxService.tellActionIsInProgress(false);
        this.router.navigate(["Error", {errMessage: err.error}]);
      }
    });

    this.getOffDaysByUser();
  }

  getOffDaysByUser() {
    this.toolsBoxService.tellActionIsInProgress(true);
    this.userService.getUserPartTime(this.selectedUser, this.selectedYear).subscribe({
      next: (configs: WorkingDayConfigHolder[]) => {
        this.workingConfigs = configs.filter(c => c.type !== 'FULL_TIME');
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      error: (err) => {
        this.toolsBoxService.tellActionIsInProgress(false);
        this.router.navigate(["Error", {errMessage: err.error}]);
      }
    });
  }

  getDayClass(rep: DayRepartition, key: keyof DayRepartition): string {
    const val = rep[key];
    if (val >= 1) return 'wc-day--full';
    if (val > 0) return 'wc-day--half';
    return 'wc-day--off';
  }

  formatEndDate(end: string): string {
    return end?.startsWith('9999') ? '' : "to " +  (this.datePipe.transform(end, 'MMM d, y') || end);
  }

  getUniqueWeekdays(events: CalendarEventHolder[]): Workday[] {
    const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

    const uniqueWorkdays = new Map<string, number>();

      events.forEach(event => {
          const currentDate = new Date(event.eventStartDate).getDay();
          const dayOfWeek = daysOfWeek[currentDate];

        if (currentDate !== 0 && currentDate !== 6) {
          uniqueWorkdays.set(dayOfWeek, event.percentOfWorkPerDay);
        }
      });

      return Array.from(uniqueWorkdays.entries()).map(([day, percentage]) => ({ day, percentage }));
  }

  allPercentagesAreOne(workdays: Workday[]): boolean {
    return workdays.every(workday => workday.percentage === 1);
  }

  getWorkTimePercent(days: Workday[]): string {
    const totalNumberWork = 40;

    const workedHour = days.filter(day => day.percentage > 0).reduce((totalHours, day) => totalHours + (day.percentage * 8), 0);

    return Math.round(((workedHour * 100) / totalNumberWork) * 10) / 10 + '%';
  }

  getUserStats = () => {
    this.toolsBoxService.tellActionIsInProgress(true);

    const userIdParam: number = this.selectedUser?this.selectedUser.id:null;
    this.userService.getUserBalance(userIdParam, this.selectedYear).subscribe(
      (holder: BalanceHolder) => {
        this.balanceYear = holder.balanceYear;
        this.currentYearBalance = holder.currentYearBalance;
        this.previousYearFinalBalance = holder.previousYearFinalBalance;
        this.offCount = holder.offCount;
        this.eholCount = holder.eholCount;
        this.takenCount = holder.takenCount;
        this.dolCount = holder.dolCount;
        this.maxDol = holder.maxDol;
        this.sickDaysCount = holder.sickDaysCount;
        this.kidsSickDaysCount = holder.kidsSickDaysCount;

        this.eholDetail = holder.eholDetail;
        this.trainDetail = holder.trainDetail;
        this.otherDetail = holder.otherDetail;
        this.sickDetail = holder.sickDetail;
        this.kidsDetail = holder.kidsDetail;
        this.offDetail = holder.offDetail;
        this.dolDetail = holder.dolDetail;
        this.pholList = holder.pholList;
        this.pendingRequests = holder.pendingRequests;
        this.nextDayOff = holder.nextDayOff;
        this.upcomingEvents = [];
        this.nextEvents = [];
        holder.upcomingEvents.forEach(element => {
          if (element.invitationStatus === "ACCEPTED" || element.invitationStatus === "MANDATORY"){
            this.nextEvents.push(element);
          } else {
            this.upcomingEvents.push(element);
          }
        })
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      (err) => {
        this.toolsBoxService.tellActionIsInProgress(false);
        if (err) {
          this.router.navigate(["Error", {errMessage: err.error}]);
        }
      });
  }


  showDetail = (code: any) => {
    this.currentDetail = null;
    this.modalLabel = '';
    this.modalType = '';
    switch (code) {
      case 'EXTRA':
        this.currentDetail = this.eholDetail;
        this.modalLabel = 'Extra-legal holidays ' + this.selectedYear;
        this.modalType = 'extra';
        break;
      case 'HOLIDAYS':
        this.currentDetail = this.offDetail;
        this.modalLabel = 'Planned / Taken Holidays ' + this.selectedYear;
        this.modalType = 'off';
        break;
      case 'SICK':
        this.currentDetail = this.sickDetail;
        this.modalLabel = 'Days for sickness ' + this.selectedYear;
        this.modalType = 'sick';
        break;
      case 'KIDS':
        this.currentDetail = this.kidsDetail;
        this.modalLabel = 'Days for kids sickness ' + this.selectedYear;
        this.modalType = 'kids';
        break;
      case 'DOL':
        this.currentDetail = this.dolDetail;
        this.modalLabel = 'Outside Luxembourg ' + this.selectedYear;
        this.modalType = 'hbw';
        break;
      default:
        break;
    }

    this.displayDetail = true;
  }

  /* Called when year is changing */
  onYearChange = (value: number) => {
    this.selectBoxOpen = false;
    if (value !== this.selectedYear) {
      // Change selected year value
      this.selectedYear = Number(value);

      this.nextEvents = [];
      this.upcomingEvents = [];

      this.getUserStats();
      this.getOffDaysByUser();
    }
  }

  /* answer invitations */
  handleParticipationResponse = (currentEvent: CalendarEventHolder, willParticipate: boolean) => {
    //In case Dashboard is displayed through Overview, there is no action allowed
    if (this.selectedUser !== null) {
      return;
    }
    currentEvent.invitationStatus = (willParticipate?"ACCEPTED":"REFUSED");
    this.toolsBoxService.tellActionIsInProgress(true);
    const result = this.userService.handleEventInvitation(currentEvent).subscribe(
      (data) => {
        this.upcomingEvents = [];
        this.nextEvents = [];
        data.map(planningItem => planningItem.event)
          .map(element => {
          if (element.invitationStatus === "ACCEPTED" || element.invitationStatus === "MANDATORY"){
            this.nextEvents.push(element);
          } else {
            this.upcomingEvents.push(element);
          }
        })
        this.toolsBoxService.tellActionIsInProgress(false);
        this.cdr.markForCheck();
      },
      (err) => {
        if (err) {
          this.router.navigate(["Error", {errMessage: err.error}]);
        }

        this.toolsBoxService.tellActionIsInProgress(false);
      })
    ;
  }

  getEventTypeDescription = (eventStatus: string) => {
    let labelDisplayed = "";
    switch (eventStatus)  {
      case "DEL_REQUESTED":
        labelDisplayed = "IN CANCELLING";
        break;
      default:
        labelDisplayed = eventStatus;
        break;
    }
    return labelDisplayed;
  }

  getSituationType(user: User) {
      if (user.parentalLeave) {
        return 'My parental leave planning';
      } else if (user.partTime) {
        return 'My part time planning';
      }
      return 'No informations';
  }

  getDolProgressWidth(): string {
    if (!this.maxDol || this.maxDol <= 0) return '0%';
    return Math.min(Math.round((this.dolCount / this.maxDol) * 100), 100) + '%';
  }

  getDolProgressClass(): string {
    if (!this.maxDol || this.maxDol <= 0) return '';
    const ratio = this.dolCount / this.maxDol;
    if (ratio >= 1) return 'hbw-bar--over';
    if (ratio >= 0.9) return 'hbw-bar--danger';
    if (ratio >= 0.8) return 'hbw-bar--warning';
    return 'hbw-bar--ok';
  }

  getDolWarningLevel(): number {
    if (!this.maxDol || this.maxDol <= 0) return 0;
    const ratio = this.dolCount / this.maxDol;
    if (ratio >= 1) return 100;
    if (ratio >= 0.9) return 90;
    if (ratio >= 0.8) return 80;
    return 0;
  }

  redirectToEventInfo = (eventId: number) => {
    this.router.navigate(["Planning/"+eventId]);
  }

  returnString(balanceYear: number): string {
    return balanceYear.toString();
  }

  returnToStringMap(years: number[]): string[] {
    return years.map(String);
  }

  displayYears () {
    return "Events " + this.years[0] + "/" + this.years[1];
  }
}
